export default {"src":"/_next/static/media/rw.badbb3e6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};